import { render, staticRenderFns } from "./ChooseCriteriaCardFooter.vue?vue&type=template&id=e981f63c"
import script from "./ChooseCriteriaCardFooter.vue?vue&type=script&lang=js"
export * from "./ChooseCriteriaCardFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports